import { collection, getDocs, query, where } from "@firebase/firestore";
import { db } from "../../../firebase";

const GetAllExams = async (ClassID, CourseID) => {
  try {
    const ExamsCollection = collection(db, "Exams");

    const q = query(
      ExamsCollection,
      where("Class", "==", ClassID),
      where("Course", "==", CourseID),
      where("IsDeleted", "==", false)
    );
    const ExamsSnapshot = await getDocs(q);

    let ExamsData = [];

    ExamsSnapshot.forEach((doc) => {
      ExamsData.push({ ...doc.data(), id: doc.id });
    });
    return ExamsData;
  } catch (error) {
    console.log(error);
  }
};

export default GetAllExams;
